import { useRef } from "react";
import { Button } from "@/components/ui/button";
import { ImagePlus, X, BookOpen } from "lucide-react";

export const PlantUpload = ({ plant, files, onChange, disabled }) => {
  const ref = useRef(null);
  const slug = plant.replace(/\s+/g, "-").toLowerCase();
  const add = (list) => onChange([...files, ...Array.from(list).filter((f) => f.type.startsWith("image/"))]);
  return (
    <div
      data-testid={`upload-zone-${slug}`}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => { e.preventDefault(); if (!disabled) add(e.dataTransfer.files); }}
      className="bg-white border-2 border-dashed border-slate-300 rounded-xl p-5 hover:border-sky-400 transition-colors"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 font-chivo font-black text-lg text-slate-900">
          <BookOpen className="h-5 w-5 text-sky-600" /> {plant} Notebook
        </div>
        <span data-testid={`upload-count-${slug}`} className="text-xs text-slate-500">{files.length} photo(s)</span>
      </div>
      <input ref={ref} type="file" accept="image/*" multiple className="hidden" data-testid={`upload-input-${slug}`}
        onChange={(e) => { add(e.target.files); e.target.value = ""; }} />
      <Button variant="outline" disabled={disabled} onClick={() => ref.current?.click()} data-testid={`upload-button-${slug}`} className="w-full h-20 border-slate-200">
        <ImagePlus className="h-5 w-5 mr-2" /> Add page photos (or drop here)
      </Button>
      {files.length > 0 && (
        <ul className="mt-3 space-y-1 max-h-40 overflow-y-auto">
          {files.map((f, i) => (
            <li key={i} className="flex items-center justify-between text-sm bg-slate-50 rounded px-2 py-1">
              <span className="truncate">Page {i + 1}: {f.name}</span>
              <button disabled={disabled} data-testid={`remove-photo-${slug}-${i}`} onClick={() => onChange(files.filter((_, j) => j !== i))} className="text-slate-400 hover:text-red-600">
                <X className="h-4 w-4" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
